import { DialogMessageType } from "@/types/commands";
import { Button } from "antd";
import * as React from "react";

const message = [
  "We allow for data uploads for select financial data categories and only within the AlphaScript Template.",
  "Please ensure you have an AlphaScript Upload Template as your selected Excel before pressing this Upload Data button.",
].join(" ");

const App: React.FC = () => {


  return (
    <div className="p-4 flex flex-col items-center justify-center text-center">
      <div className="text-sm text-left space-y-2">
        <p><strong>Do you have an AlphaScript upload template open? We don’t identify your   
        Excel as an AlphaScript template. See step 2 below.</strong></p>
        <p>
          Upload your proprietary data to AlphaScript and use it across the platform.
          <strong> Follow these steps:</strong>
        </p>

        <ol className="list-decimal ml-6 space-y-1">
          <li>
            <strong>Choose your data type</strong> (e.g., capitalization, financials).
          </li>
          <li>
            <strong>Open the Upload Template</strong> from the Excel Add-in ribbon and select the template for your data.
          </li>
          <li>
            <strong>Fill out the template</strong> with your data.
          </li>
          <li>
            <strong>Complete this Upload Data form</strong>, ensuring the matching Excel template is open.
          </li>
        </ol>
      </div>
      <Button
        type="primary"
        onClick={() => Office.context.ui.messageParent(JSON.stringify({ action: DialogMessageType.CLOSE }))}
        style={{
          marginTop: 16,
          padding: "6px 12px",
          fontSize: 13,
          cursor: "pointer",
        }}
        className="!text-white font-bold text-lg"
      >
        Close
      </Button>
    </div>
  );
};

export default App;


